import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { DialogAction } from '../../../function/useModal';
import { useTranslation } from 'react-i18next';
import XYComparisonSetting from '../../Pages/GroupSettings/XYCompansonSetting/XYComparisonSetting';
import { SettingsState } from '../../organisms/SelectSettings';

type XYSettingDialogProps = {
  dialog: DialogAction<XYSettingDialogResponse>;
  groupNo: number;
}

export type XYSettingDialogResponse = {};

const useStyles = makeStyles(
  createStyles({
    dialog: {
      background: '#FFFFEE',
    },
  })
);

const XYSettingDialog: React.FC<XYSettingDialogProps> = (props: XYSettingDialogProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);
  const [no, setNo] = useState<number>(props.groupNo);
  const [editData, setEditData] = useState<SettingsState>(new SettingsState());
  const [dummyIdx, setDummyIdx] = useState<number>(0);

  useEffect(() => {
    //console.debug('-- useEffect editData --', editData)
    editData.DispatchIndex = setDummyIdx;
  }, [editData]);

  useEffect(() => {
    console.debug(['-- useEffect dummyIdx --', editData.IsUpdate, dummyIdx])
    if (dummyIdx < 0) {
      setIsOpen(false);
      setMode(editData.IsSaveClose);
    }
  }, [dummyIdx]);

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        maxWidth={'xl'}
        onEntered={(e) => { }}
        onExited={(e) => {
          if (mode) {
            //console.debug('props.dialog.apply() test')
            props.dialog.apply({});
          } else {
            //console.debug('props.dialog.cancel() test')
            props.dialog.cancel();
          }
        }}
        PaperProps={{ className: classes.dialog }}
      >
        <DialogTitle>{t('XYSettingDialog.XY分布グループ設定', 'X-Y分布グループ設定')}</DialogTitle>
        <DialogContent>
          <XYComparisonSetting editData={editData} groupNo={props.groupNo} isDialog={true} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default XYSettingDialog;